import type { FaireProductEntity } from "../../entity_types/product";

export const p_t4vsptb83s: FaireProductEntity = {
  token: "p_t4vsptb83s",
  type: "product",
  name: "Solid color V-neck burn half sleeve A-line dress",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Lily Clothing",
  imageUrl:
    "https://cdn.faire.com/fastly/ea2a887e821871a96843df0fe6120eb05823f5799137d3951e8bb85a5f3f05ec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/98011ae52232fa024a1474d449ef3091f60dc43758f178670e47bc560a017c30.jpeg",
    "https://cdn.faire.com/fastly/0637fbb4c9ff943088356894335e1ddf536a98b44187d89b66dee2d86b268524.jpeg",
    "https://cdn.faire.com/fastly/f8bb9c63c73e83005004176690e41f4a48e11dc78d3e5c74db84c6394f18f781.jpeg",
    "https://cdn.faire.com/fastly/bafdbd2c2f07ff86fcacebf7627622a4cd67f2015b9b0b4dc0127e3ac701bae0.jpeg",
    "https://cdn.faire.com/fastly/d3e1ba5bdef273764ec07263563e63fc08cf018f45ee54f59512dff14ca43627.jpeg",
    "https://cdn.faire.com/fastly/3757e3474fccf753db959230e7796a8744bedc58540ef50430e9134817614a0e.jpeg",
    "https://cdn.faire.com/fastly/8a099d983fcc2e335e6b95b796319eb16dcbde85b01aa04ba8cfbd31171e51c5.jpeg",
    "https://cdn.faire.com/fastly/74bca782f3b42bb4d0fe8ac486f8d5e53622f8e1e388974e88d72a0544fca8e0.jpeg",
    "https://cdn.faire.com/fastly/1664d342b68af0cbf43811744c3f7aa96c0bccccc10c92a5d3b10c78b9e881ee.jpeg",
  ],
  priceDollars: 8.66,
  description:
    "Solid color V-neck burn half sleeve A-line dress\n95% Polyester, 5% Spandex\nSizes: S, M, L, XL\nMade in China\n\nDress, spring dress, Summer dress, Fall dress, Winter dress, dress pants, dress front, dress pocket, lesbian dress, dress mature women, mid-length dress, dress, large dress, split skirt, floor dress, high-waist dress, Mid-waist dress, Tunic dress, tunic dress, Western dress, Spring dress, Summer dress, long-sleeved dress, short-sleeved dress, patchwork dress, halter dress, vest dress, cutout dress, crew-neck dress, line-neck dress, V-neck dress, wedding dress, Wedding dress, Homecoming dress, Bridesmaid dress, Cocktail dress, Prom dress, denim dress, Midi dress, graduation dress, ski dress, sequin dress, gown",
  tags: [],
  msrpDollars: 17.32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:37.010Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
